import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchFollowing } from '../../actions/fetch-following';
import { clearFollowing } from '../../actions/clear-following';
import { fetchUserAndRedirect } from '../../actions/fetch-user-and-redirect';
import { redirectTo404 } from '../../actions/redirect-to-404';
import AppLoaded from '../../components/app-loaded';
import DefaultDesktopLayout from '../../components/default-desktop-layout';
import AnimatedLoader from '../../components/animated-loader';
import MemberList from '../../components/member-list';
import EmptyState from '../../components/empty-states';
import InfiniteListLoader from '../../components/infinite-list-loader';
import Loader from '../../components/loader';
import Button from '../../components/button';
import { MEMBERS_PER_PAGE } from '../../constants/pagination';
import withEnvironment from '../../hoc/with-environment';
import withTranslate from '../../hoc/with-translate';
import { getCurrentUserSlug } from '../../selectors/current-user-selectors';
import { getIsFollowingLoading } from '../../selectors/is-loading-selectors';
import { getFollowing, getFollowerCount } from '../../selectors/following-selectors';
import { getUserBySlug } from '../../selectors/user-selectors';

const reset = () => ({ page: 1 });
const increment = state => ({ page: state.page + 1 });

export class FollowingPage extends Component {
  static fetchData = ({ store, params, search }) =>
    store
      .dispatch(fetchUserAndRedirect(params.userSlug, search))
      .then(user =>
        store.dispatch(
          fetchFollowing({
            userId: user._id,
            page: 1,
            pageSize: MEMBERS_PER_PAGE,
          })
        )
      )
      .catch(() => store.dispatch(redirectTo404(search)));

  state = { page: 1 };

  componentDidMount = () => this.fetchFollowing();
  componentWillUnmount = () => this.props.clearFollowing();

  componentWillReceiveProps = ({ userId }) => {
    if (this.props.userId !== userId) {
      this.props.clearFollowing();
      this.setState(reset, () => this.fetchFollowing(userId));
    }
  };

  fetchFollowing = (userId = this.props.userId, page = this.state.page) =>
    this.props.fetchFollowing({
      userId,
      page,
      pageSize: MEMBERS_PER_PAGE,
    });

  handleLoad = () => this.setState(increment, this.fetchFollowing);

  renderEmptyState = () => {
    const { isCurrentUser, t, navigation: { MembersLink } } = this.props;
    const suffix = isCurrentUser ? '-current-user' : '';
    return (
      <EmptyState
        title={t(`following-page.empty-state-title${suffix}`)}
        content={t(`following-page.empty-state-content${suffix}`)}
      >
        {isCurrentUser ?
          <Button component={MembersLink}>
            {t('following-page.members-page-link')}
          </Button> :
          null}
      </EmptyState>
    );
  };

  renderMemberList = () => {
    const { isLoading, following, count } = this.props;
    return (
      <DefaultDesktopLayout>
        <MemberList members={following}/>
        <InfiniteListLoader
          onLoad={this.handleLoad}
          loader={<Loader/>}
          isLoading={isLoading}
          hasMore={following.length < count}
        />
      </DefaultDesktopLayout>
    );
  };

  render = () => {
    const { isLoading, following } = this.props;
    return (
      <div>
        <AnimatedLoader isLoading={isLoading && !following.length}>
          {following.length ? this.renderMemberList() : this.renderEmptyState()}
        </AnimatedLoader>
        <AppLoaded/>
      </div>
    );
  };
}

FollowingPage.propTypes = {
  count: PropTypes.number.isRequired,
  fetchFollowing: PropTypes.func.isRequired,
  clearFollowing: PropTypes.func.isRequired,
  isCurrentUser: PropTypes.bool.isRequired,
  userId: PropTypes.string.isRequired,
  params: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  following: PropTypes.array,
  navigation: PropTypes.object,
  t: PropTypes.func,
};

const mapStateToProps = (state, ownProps) => ({
  isCurrentUser: getCurrentUserSlug(state) === ownProps.params.userSlug,
  userId: getUserBySlug(state, ownProps.params.userSlug)._id,
  isLoading: getIsFollowingLoading(state),
  following: getFollowing(state),
  count: getFollowerCount(state),
});

const mapDispatchToProps = {
  fetchFollowing,
  clearFollowing,
};

export default flowRight(
  connect(mapStateToProps, mapDispatchToProps),
  withEnvironment({ navigation: 'navigation' }),
  withTranslate
)(FollowingPage);



// WEBPACK FOOTER //
// ./app/containers/following-page/following-page.js